import './ArticleListItem.scss'

import { useRef, useEffect } from 'react'
import { useHistory } from 'react-router-dom'

import { ROUTE_ARTICLES_BASE } from 'components/common/helpers/Paths'
import { navigateTo } from 'components/common/navigation'
import { Col, Row } from 'react-bootstrap'

import alternativeCourseImage from '../../../assets/images/alternative-course-image.jpeg'
import { buildRequestURL } from 'components/common/api'

//get short month name from ISO string
const shortMonthName = new Intl.DateTimeFormat('en-US', { month: 'short' })
  .format

/**
 * Simple article List item component. Used to display article item title and preview
 */
export default function ArticleListItem({ article, observer, returnPath = null }) {
  const history = useHistory()
  const previewRef = useRef()

  const date = new Date(article['date'])
  const thumbnailSrc = article['featured_image_thumbnail_url'] && article['featured_image_thumbnail_url'] !== ''
    ? article['featured_image_thumbnail_url']
    : alternativeCourseImage
  const mainImageSrc = article['featured_image_url'] && article['featured_image_url'] !== ''
    ? article['featured_image_url']
    : alternativeCourseImage

  /**
   * Helper function to open the article page after clicking on it
   */
  const handleCardClick = article => {
    const url = buildRequestURL(`${ROUTE_ARTICLES_BASE}/${article.id}`, { returnPath })
    navigateTo(url, history)
  }

  useEffect(() => {
    // Return early of we don't have article data yet
    if (!article || !observer) return

    // Add to the observer
    observer.observe(previewRef.current)
  }, [article, observer])

  return (
    article && (
      <Row
        className='articles-list-item py-4'
        onClick={() => handleCardClick(article)}
      >
        <Col xs={4} md={3} lg={2} className='article-image'>
          <img
            loading='lazy'
            ref={previewRef}
            className='rounded-2'
            src={thumbnailSrc ?? mainImageSrc}
            alt={article['main-image']?.alt ?? 'article image'}
          />
        </Col>
        <Col xs={8} md={9} lg={10}>
          {date && (
            <small className='publish-date'>
              {`${date.getDate()} ${shortMonthName(
                date
              )} ${date.getFullYear()}`}
            </small>
          )}
          <h5 className='article-title mt-2 mb-0'>{article.title.rendered}</h5>
        </Col>
      </Row>
    )
  )
}
